import axios from 'axios'
import { useAuthStore } from '@/store/auth'
//import StorageService from './StorageService'
//import router from '../router'

class HTTPService {
  http_common() {
    const baseDomain = process.env.VUE_APP_API_URL
    const http = axios.create({
      baseURL: baseDomain,
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true, // Set withCredentials to true
    })
    http.interceptors.request.use((config) => {
      const auth = useAuthStore()
      if (auth.token) {
        config.headers.Authorization = `Bearer ${auth.token}`
      }
      return config
    })
    return http
  }

  async createChatbot(formData) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return await http
      .post('/create-chatbot', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async createChatbotByMainChat(formData) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return await http
      .post('/create-chatbot-by-main-chat', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async createChatbotBySummary(formData) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return await http
      .post('/create-chatbot-by-summary', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  conversation(text, bot_id) {
    //const auth = useAuthStore()
    const http = this.http_common()
    return http
      .post(
        '/conversation',
        {
          text,
          bot_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            //Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }
  gethistory() {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http.get('/history', {
      headers: {
        'Content-Type': 'multipart/form-data',
        //Authorization: `Bearer ${auth.token}`,
      },
    })
  }

  get_chatbots(navId, tenantId = 999) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http
      .post(
        '/chatbots',
        {
          nav_id: navId,
          tenant_id: tenantId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            //Authorization: 'Bearer ${auth.token}`,
          },
        },
      )
      .catch((error) => {
        return Promise.reject(error)
      })
  }

  changePassword(password, newPassword) {
    //const auth = useAuthStore()
    const http = this.http_common()
    return http.post(
      '/change_password',
      {
        new_password: newPassword,
        old_password: password,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          //Authorization: `Bearer ${auth.token}`,
        },
      },
    )
  }

  getuser() {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http
      .get(process.env.VUE_APP_SAML2_SESSION_CECHK, {
        //.get('/get_user', {
        headers: {
          'Content-Type': 'multipart/form-data',
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  }

  //getfile(filename) {
  //getfile(data) {
  //  //let token = StorageService.getToken()
  //  let http = this.http_common()
  //
  //  http
  //    //.get('/files/' + sanitizedFilename, {
  //    .post('/files', data, {
  //      headers: {
  //        //Authorization: `Bearer ${token}`,
  //        'Cache-Control': 'no-cache',
  //        Pragma: 'no-cache',
  //        Expires: '0',
  //     },
  //      //responseType: 'blob',
  //    })
  //    .then((response) => {
  //      fetch(response.data.s3_url, {
  //        mode: 'cors',
  //      })
  //        .then((response) => {
  //          if (!response.ok) {
  //            throw new Error('ファイルを読み込めませんでした。')
  //          }
  //          return response.blob()
  //        })
  //        .then((blob) => {
  //          const blobUrl = window.URL.createObjectURL(blob)
  //          const link = document.createElement('a')
  //          link.href = blobUrl
  //          link.download = data.filename
  //          document.body.appendChild(link)
  //          link.click()
  //          document.body.removeChild(link)
  //          window.URL.revokeObjectURL(blobUrl)
  //        })
  //        .catch((error) => {
  //          console.error('ダウンロード失敗:', error)
  //          this.errorMessage =
  //            'ファイルの読み込みに失敗しました。再度実行ください。'
  //          this.showErrorPopup = true
  //        })
  //    })
  //}

  getfile(data) {
    //const auth = useAuthStore()
    let http = this.http_common()
    /*
    const fetchAndDownload = (url, filename, retry = false) => {
      fetch(url, { mode: 'cors' })
        .then((response) => {
          if (!response.ok) {
            if (!retry && filename.toLowerCase().endsWith('.pdf')) {
              // retry with .jpg
              const jpgFilename = filename.replace(/\.pdf$/i, '.jpg')
              const newData = { ...data, filename: jpgFilename }
              this.getfile(newData) // 再帰的に再試行
              return
            }
            throw new Error('ファイルを読み込めませんでした。')
          }
          return response.blob()
        })
        .then((blob) => {
          if (!blob) return // 再試行したときは無視
          const blobUrl = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = blobUrl
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(blobUrl)
        })
        .catch((error) => {
          console.error('ダウンロード失敗:', error)
          this.errorMessage =
            'ファイルの読み込みに失敗しました。再度実行ください。'
          this.showErrorPopup = true
        })
    }

    http
      .post('/files', data, {
        headers: {
          //Authorization: `Bearer ${auth.token}`,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
      })
      .then((response) => {
        fetchAndDownload(response.data.s3_url, data.filename)
      })
    */
    http
      .post('/files', data, {
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
      })
      .then((response) => {
        this.fetchAndDownload(response.data.s3_url, data.filename, {
          retryCallback: (newFilename) => {
            const newData = { ...data, filename: newFilename }
            this.getfile(newData)
          },
          onError: () => {
            this.errorMessage =
              'ファイルの読み込みに失敗しました。再度実行ください。'
            this.showErrorPopup = true
          },
        })
      })
  }

  fetchAndDownload(url, filename, options = {}) {
    const {
      retryCallback = null, // 再試行用
      onError = null, // エラー時のコールバック
    } = options

    return fetch(url, { mode: 'cors' })
      .then((response) => {
        if (!response.ok) {
          if (retryCallback && filename.toLowerCase().endsWith('.pdf')) {
            const jpgFilename = filename.replace(/\.pdf$/i, '.jpg')
            retryCallback(jpgFilename)
            return
          }
          throw new Error('ファイルを読み込めませんでした。')
        }
        return response.blob()
      })
      .then((blob) => {
        if (!blob) return

        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
      })
      .catch((error) => {
        console.error('ダウンロード失敗:', error)
        if (onError) onError(error)
      })
  }

  getplan(plan_id) {
    //const auth = useAuthStore()
    let http = this.http_common()
    //if (!token) {
    //  console.log('no token')
    //  router.push('/login')
    //}
    //console.log('test2')
    //console.log(plan_id)
    return http.post(
      `/get_plan`,
      {
        plan_id: plan_id,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          //Authorization: `Bearer ${auth.token}`,
        },
      },
    )
  }

  subscribe(body) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http.post('/subscribe', body, {
      headers: {
        'Content-Type': 'application/json',
        //Authorization: `Bearer ${auth.token}`,
      },
    })
  }
  unsubscribe() {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http.post(
      '/unsubscribe',
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          //Authorization: `Bearer ${auth.token}`,
        },
      },
    )
  }
  canceluser() {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http.post(
      '/cancel_user',
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          //Authorization: `Bearer ${auth.token}`,
        },
      },
    )
  }

  login(email, password) {
    let http = this.http_common()
    return http.post('/login_user', {
      email: email,
      password: password,
    })
  }

  resetPassword(emailAddress) {
    let http = this.http_common()
    return http.post(`/reset_password`, {
      email: emailAddress,
    })
  }

  register(firstname, lastname, email, password) {
    let http = this.http_common()
    return http.post('/register_user', {
      firstname: firstname,
      lastname: lastname,
      email: email,
      password: password,
    })
  }
  upload(file, use_free_server = null) {
    let http = this.http_common()
    //const auth = useAuthStore()
    let formData = new FormData()
    formData.append('file', file)
    formData.append(
      'data',
      JSON.stringify({ use_free_server: use_free_server }),
    )
    return http.post('/upload_detect', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        //Authorization: `Bearer ${auth.token}`,
      },
    })
  }
  sendconfirmemail(body) {
    let http = this.http_common()
    return http.post('/send_confirm_email', body)
  }
  confirmRegistration(token) {
    let http = this.http_common()
    return http.post(`/confirm_registration/${token}`)
  }

  subscribesuccess(success_id1) {
    //const auth = useAuthStore()
    let http = this.http_common()
    // return http.post(`/subscribe_success?success_id=${success_id}`, null, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     //Authorization: `Bearer ${auth.token}`,
    //   },
    // })
    return http
      .post(
        `/subscribe_success`,
        {
          success_id: success_id1,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            //Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  update_chatbot(editingChatbot) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http.post(
      `/update_chatbot`,
      {
        chatbot: editingChatbot,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          //Authorization: `Bearer ${auth.token}`,
        },
      },
    )
  }

  get_conversation_history(bot_id) {
    //const auth = useAuthStore()
    let http = this.http_common()

    // 単体なら配列化
    const botIds = Array.isArray(bot_id) ? bot_id : [bot_id]

    return http
      .post(
        '/get_conversation_history',
        {
          bot_id: botIds,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            //Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
          return
        }
        throw error
      })
  }

  get_conversation(conversation_id) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http
      .get(`/get_conversation?conversation_id=${conversation_id}`, {
        headers: {
          'Content-Type': 'application/json',
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  get_conversationByGenerateImag(conversation_id) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http
      .get(
        `/get_conversation-by-generate-image?conversation_id=${conversation_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            //Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  get_conversation_status() {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http
      .get('/get-conversation-status', {
        headers: {
          //'Content-Type': 'application/json',
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        //if (error.response && error.response.status === 401) {
        //  localStorage.setItem('expired', 'true')
        //  window.location.href = '/login'
        //}
        throw error
      })
  }

  async delete_conversation(data) {
    let http = this.http_common()
    //const auth = useAuthStore()
    return await http
      .post('/delete-conversation', data, {
        headers: {
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  get_style(bot_id) {
    let http = this.http_common()
    return http.get(`/get_style?bot_id=${bot_id}`)
  }

  get_url(url, max_level_get_url) {
    // ////console.log(url)
    //const auth = useAuthStore()
    let http = this.http_common()
    return http.post(
      `/get_urls`,
      {
        url: url,
        max_level_get_url: max_level_get_url,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          //Authorization: `Bearer ${auth.token}`,
        },
      },
    )
  }

  async conversationByGenerateImage(payload) {
    let http = this.http_common()
    //const auth = useAuthStore()
    return http
      .post('/conversation-by-generate-image', payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async edit_image(payload) {
    let http = this.http_common()
    //const auth = useAuthStore()
    return http.post('/edit-image', payload, {
      headers: {
        //Authorization: `Bearer ${auth.token}`,
      },
    })
  }

  async translate_file(formData) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return await http
      .post('/translate-file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async transcribe_audio(formData) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return await http
      .post('/transcribe-audio', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async check_ocr(formData) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return await http
      .post('/ocr', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async delete_file(data) {
    let http = this.http_common()
    //const auth = useAuthStore()
    return await http
      .post('/delete-chatbot-file', data, {
        headers: {
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async delete_office_file(filepath) {
    let http = this.http_common()
    //const auth = useAuthStore()
    return await http
      .post(
        '/delete-office-file',
        { filepath: filepath },
        {
          headers: {
            //Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async delete_chatbot(data) {
    let http = this.http_common()
    //const auth = useAuthStore()
    return await http
      .post('/delete-chatbot', data, {
        headers: {
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async deleteChatbotByMainChat(data) {
    let http = this.http_common()
    //const auth = useAuthStore()
    return await http
      .post('/delete-chatbot-by-main-chat', data, {
        headers: {
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async deleteChatbotByGenerateImage(data) {
    let http = this.http_common()
    //const auth = useAuthStore()
    return await http
      .post('/delete-chatbot-by-generation-image', data, {
        headers: {
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async update_chatbot_display_order(data) {
    let http = this.http_common()
    //const auth = useAuthStore()
    return await http
      .post('/update-chatbot-display-order', data, {
        headers: {
          //Authorization: `Bearer ${auth.token}`,
        },
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async office_file_download(messageId, type, longText) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http
      .post(
        '/office-file-download',
        { message_id: messageId, type: type, long_text: longText },
        {
          headers: {
            'Content-Type': 'application/json',
            //Authorization: `Bearer ${auth.token}`,
          },
        },
      )
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }

  async link_preview(url) {
    //const auth = useAuthStore()
    let http = this.http_common()
    return http
      .post(
        '/link-preview',
        { url: url },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.setItem('expired', 'true')
          window.location.href = '/login'
        }
        throw error
      })
  }
}
const FREEPLANS = [
  {
    id: 'free',
    name: 'Free',
    description: 'Free Plan',
    price: '$0',
    chatbots: 1,
    messages: '5 messages / day',
    characters: '1,000,000 characters (~1MB) / chatbot',
    features: ['Install chatbot on website'],
  },
]
const CUSTOMPLANS = [
  {
    id: 'custom',
    name: 'Custom',
    description: 'Custom Self Hosted',
    price: '$$$',
    chatbots: 'Unlimited',
    messages: 'Unlimited',
    characters: 'Unlimited',
    features: [
      'Onsite Company Self Hosted',
      'Data Privacy',
      'Install chatbot on website',
      'API access',
    ],
  },
]
const PLANS = [
  {
    id: 'free',
    name: 'Free',
    description: 'Free Plan',
    price: '$0',
    chatbots: 1,
    messages: '5 messages / day',
    characters: '1,000,000 characters (~1MB) / chatbot',
    features: ['Install chatbot on website'],
  },
  {
    id: 'standard',
    name: 'Standard',
    description: 'Chatbot AI Standard Plan',
    price: '$15',
    chatbots: 15,
    messages: '600 messages / month',
    characters: '3,000,000 characters (~3MB) / chatbot',
    features: ['Install chatbot on website', 'API access'],
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '$50',
    description: 'Chatbot AI Pro Plan',
    chatbots: 25,
    messages: '3,000 messages / month',
    characters: '5,000,000 characters (~5MB) / chatbot',
    features: ['Install chatbot on website', 'API access'],
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    description: 'Chatbot AI Enterprise Plan',
    price: '$250',
    chatbots: 50,
    messages: '250,000 messages / month',
    characters: '10,000,000 characters (~10MB) / chatbot',
    features: ['Install chatbot on website', 'API access'],
  },
  {
    id: 'custom',
    name: 'Custom',
    description: 'Custom Self Hosted',
    price: '$$$',
    chatbots: 'Unlimited',
    messages: 'Unlimited',
    characters: 'Unlimited',
    features: [
      'Onsite Company Self Hosted',
      'Data Privacy',
      'Install chatbot on website',
      'API access',
    ],
  },
]

export { PLANS, CUSTOMPLANS, FREEPLANS }

export default new HTTPService()
